<template lang="pug">
  DataTablePage(
    mainColumn="waterUserCode"
    longColumn="waterUserCode"
    resource="meterReading/event"
    title="事件管理"
    label="事件"
    labelName="eventTypeName"
    :operation="operation"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :operationWidth="70"
    :columns="columns")
</template>

<script>
import DataTablePage from '@/containers/DataTablePage'
import { operationEventImages } from '@/containers/DataTablePage/operation'
import fullColumns from '@/containers/meterReading/fullColumns'

export default {
  name: 'Incident',
  components: {
    DataTablePage
  },
  data () {
    return {
      operation: [{
        label: '事件明细',
        name: 'detail',
        icon: 'info',
        tooltip: true,
        func: operationEventImages
      }],
      tableInitList: ['createTime', 'eventSceneId', 'eventTypeId', 'areaCode', 'bookCode', 'waterUserCode', 'waterUserName', 'waterUserAddress', 'createUserId'],
      tableFullList: ['createTime', 'eventSceneId', 'eventTypeId', 'areaCode', 'bookCode', 'waterUserCode', 'waterUserName', 'waterUserAddress', 'createUserId'],
      filterInitList: [],
      filterFullList: [],
      columns: {
        ...fullColumns,
        areaCode: {
          label: '区',
          style: {
            textAlign: 'center'
          },
          width: 70,
          filter: {
            width: 70,
            type: 'input'
          }
        },
        bookCode: {
          label: '本',
          style: {
            textAlign: 'center'
          },
          width: 60,
          filter: {
            width: 70,
            type: 'input'
          }
        },
        waterUserCode: {
          label: '户号',
          style: {
            textAlign: 'center'
          },
          width: 110,
          minLength: 200
        },
        waterUserName: {
          label: '户名',
          width: 200,
          filter: {
            type: 'input'
          }
        },
        createTime: {
          label: '记录时间',
          type: 'time',
          dateType: 'YYYY-MM-DD HH:mm:ss',
          style: {
            textAlign: 'center'
          },
          width: 165
        },
        createUserId: {
          label: '记录人',
          type: 'select',
          style: {
            textAlign: 'center'
          },
          width: 110,
          relation: 'users',
          filter: {
            type: 'select',
            live: true
          }
        },
        createUserName: {
          label: '记录人',
          style: {
            textAlign: 'center'
          },
          width: 200
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Incident.vue?5d824e5a